<template>
  <div class="help padding_top">
    <p><strong>步骤：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【个人主页】</span>，即可进入【医生工作室】，在顶部菜单栏中点击<span
        class="orange">【咨询历史】</span>，页面展示【咨询历史】列表
    </p>
    <img src="../../../assets/doctorImg/historyConsultation.png" alt="">
  </div>
</template>

<script>
export default {
  name: "historyConsultation",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
